import { RouteObject } from 'react-router';

import { CustomerDetails } from './Details';
import { CustomerList } from './List';

export const CUSTOMER_ROUTES: RouteObject[] = [
    {
        index: true,
        Component: CustomerList,
    },
    {
        path: ':id',
        Component: CustomerDetails,
    },
];
